export { default } from './ProductsSlider';
